import { CreateDonationRequestModeEnum } from '@/app/api';
import { Routes } from '@/app/enums';
import { useProjectData } from '@/app/providers/ProjectProvider';
import { envs } from '@/app/utils/envs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useDonateLink = (
  activeGoodHabitAmount: number | undefined,
  selectedDonationMode?: CreateDonationRequestModeEnum,
) => {
  const {
    i18n: { language },
  } = useTranslation();
  const { project, subProject } = useProjectData();

  const donateLink = useMemo(() => {
    const languageQuery = language === 'en' ? `lang=${language}` : '';
    const longTermQuery = selectedDonationMode === CreateDonationRequestModeEnum.LongTerm ? 'mode=long-term' : '';
    const subProjectQuery = subProject ? `subproject=${subProject.id}` : '';

    const joinedParams = [languageQuery, longTermQuery, subProjectQuery].filter(Boolean).join('&');

    const searchPrams = joinedParams ? `?${joinedParams}` : '';

    if (activeGoodHabitAmount) {
      return `${envs.redirectUrl}/${Routes.USE_GOOD_HABIT}/${project.numericId}${searchPrams}`;
    }

    return `/${Routes.DONATION}/${project.numericId}${searchPrams}`;
  }, [project.numericId, activeGoodHabitAmount, language, selectedDonationMode, subProject]);

  return donateLink;
};
